export default __webpack_public_path__ + "static/media/switchBox.fa5b36a4.svg";